import React from "react"

export default function Footer() {
  return (
    <footer className="container py-5">
      <p className="text-center">© Copyright 2021, antsle, inc.</p>
    </footer>
  )
}
